module.exports = __webpack_public_path__ + "static/media/plus_minus.7739ae4e.svg";